import BSN from "bootstrap.native/dist/bootstrap-native.esm.min"

document.addEventListener('turbolinks:load', function () {
  BSN.initCallback(document.body)
})
